module.exports = __webpack_public_path__ + "course-catalog-banner-bgwp4b55f9d3c2ec6b37fb436a4cbc844372.png";